import React from "react";
import type { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLTableRowElement>;

const CollectionRow = (props: Props): JSX.Element => (
  <tr {...props} />
);

export default CollectionRow;
